(function () {
  if (window.__andskyImageProtection) return;
  window.__andskyImageProtection = true;

  var protectedSelector = [
    'img',
    'picture',
    'video',
    'canvas',
    '.product__media',
    '.media',
    '.card__media',
    '.xtrv-card',
    '.xtrv-media',
    '.xtx-card',
    '.xtx-frame',
    '.xtx-clip',
    '[data-x-image-protect]'
  ].join(',');

  function isElement(value) {
    return value && value.nodeType === 1;
  }

  function isProtectedTarget(target) {
    return isElement(target) && Boolean(target.closest(protectedSelector));
  }

  function block(event) {
    event.preventDefault();
    event.stopPropagation();
    if (event.stopImmediatePropagation) event.stopImmediatePropagation();
    return false;
  }

  function applyProtection(root) {
    var scope = root && root.querySelectorAll ? root : document;
    scope.querySelectorAll('img, picture, video, canvas').forEach(function (node) {
      node.setAttribute('draggable', 'false');
      node.setAttribute('data-x-image-protect', 'true');
      if (node.tagName === 'IMG') {
        node.decoding = node.decoding || 'async';
      }
    });
  }

  function protectClipboard(event) {
    var selection = window.getSelection && window.getSelection();
    if (!selection || selection.rangeCount === 0) return;
    var parent = selection.getRangeAt(0).commonAncestorContainer;
    if (parent && parent.nodeType !== 1) parent = parent.parentElement;
    if (isProtectedTarget(parent)) block(event);
  }

  function protectKeys(event) {
    var key = String(event.key || '').toLowerCase();
    var mod = event.ctrlKey || event.metaKey;

    if (key === 'f12') {
      block(event);
      return;
    }

    if (!mod) return;

    if (key === 's' || key === 'u') {
      block(event);
      return;
    }

    if (event.shiftKey && (key === 'i' || key === 'j' || key === 'c')) {
      block(event);
    }
  }

  document.documentElement.classList.add('x-image-protecting');
  applyProtection(document);

  document.addEventListener('contextmenu', function (event) {
    block(event);
  }, true);

  document.addEventListener('pointerdown', function (event) {
    if (event.button === 2) block(event);
  }, true);

  document.addEventListener('mousedown', function (event) {
    if (event.button === 2) block(event);
  }, true);

  document.addEventListener('dragstart', function (event) {
    if (isProtectedTarget(event.target)) block(event);
  }, true);

  document.addEventListener('selectstart', function (event) {
    if (isProtectedTarget(event.target)) block(event);
  }, true);

  document.addEventListener('copy', protectClipboard, true);
  document.addEventListener('keydown', protectKeys, true);

  new MutationObserver(function (mutations) {
    mutations.forEach(function (mutation) {
      mutation.addedNodes.forEach(function (node) {
        if (!node || node.nodeType !== 1) return;
        if (node.matches && node.matches('img, picture, video, canvas')) {
          node.setAttribute('draggable', 'false');
          node.setAttribute('data-x-image-protect', 'true');
        }
        applyProtection(node);
      });
    });
  }).observe(document.documentElement, { childList: true, subtree: true });

  try {
    console.info('%cAndSky media protection active. Unauthorized image reuse is prohibited.', 'color:#f58220;font-weight:700;');
  } catch (error) {}
})();